import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { smoothlyMenu } from '../_helpers';
import $ from 'jquery';
import { authenticationService } from '../_services';
import { Notif } from '../_components';

class TopHeader extends Component {
  render() {
    return (
      <div className="row border-bottom">
        <nav className="navbar navbar-static-top" role="navigation" style={{ marginBottom: 0 }}>
          <div className="navbar-header">
            <span className="navbar-minimalize minimalize-styl-2 btn btn-primary" onClick={(e) => this.toggleNavigation(e)} style={{ cursor: 'pointer' }}><i className="fa fa-bars"/> </span>
            <form role="search" className="navbar-form-custom" method="post" action="#">
              <div className="form-group">
                
              </div>
            </form>
          </div>
          <ul className="nav navbar-top-links navbar-right">
            <li>
              <a onClick={()=>this.logout()}> <i className="fa fa-sign-out"/> Logout</a>
            </li>
          </ul>
        </nav>
      </div>
    );
  }

   logout() {
        authenticationService.logout();
        this.props.history.push('/login');
        Notif(`Let's start again !`, 'You not login now','toast-top-right','4')
    }


  toggleNavigation(e) {
    e.preventDefault();
    $('body').toggleClass('mini-navbar');
    smoothlyMenu();
  }
}

export { TopHeader }